// extracted by mini-css-extract-plugin
module.exports = {"Slide":"Gallery_Slide__3zpEe","LightBox":"Gallery_LightBox__1Y587"};